import { IVehicle } from '../../../structures/interfaces/Vehicle';

export const BuildVehiclesSlug = (vehicles: IVehicle[]): IVehicle[] => {
  return vehicles?.map(vehicle => ({
    ...vehicle,
    slug: `${vehicle.vehicleModel} ${vehicle.bodywork} ${vehicle.axlesAmount} ${vehicle.bagsCapacity} ${vehicle.weightCapacity}`.toLowerCase(),
  }));
};
